import React, { useCallback } from 'react';
import { SubMenu } from 'rc-menu';
import { unifiedStopPropagation } from '../../../util/unifiedStopPropagation';
import { getItemsIntoComponentsTransformer } from '../util/getItemsIntoComponentsTransformer';
import { DropdownComponentProps } from './types';

export const SubDropdown: React.FC<DropdownComponentProps> = ({
  item,
  itemLevel,
  ...props
}) => {
  const transformItemsIntoComponents = useCallback(
    getItemsIntoComponentsTransformer(itemLevel),
    [itemLevel],
  );

  return (
    <SubMenu
      {...props}
      title={item.title()}
      onTitleClick={unifiedStopPropagation}
    >
      {transformItemsIntoComponents(item.children())}
    </SubMenu>
  );
};

SubDropdown.displayName = 'SubDropdown';
